<template>
    <page>

        <module v-if="power('b_home_work')" title="实时概况" height="auto">
            <div class="realtime-total flex-wrap">
                <div  v-for="(item, i) in todayDataList" :key="i" class="item-box" >
                    <div class="item" :class="{'z-active': item.to_page}" @click="item.to_page ? navigateTo(item.to_page) : ''">
                        <label>{{item.name}}</label>
                        <div>{{item.tody_count}}</div>
                        <p v-if="item.yesterday_count!=null">
                            <span>昨日:{{item.yesterday_count}}</span>
                            <span v-if="item.ratio != 0">{{item.ratio}}%</span>
                            <i v-if="item.ratio > 0" class="tf tf-sort-up" style="color: #EB0000"></i>
                            <i v-if="item.ratio < 0" class="tf tf-sort-down" style="color: green"></i>
                        </p>
                    </div>
                </div>
            </div>
        </module>

        <module-group v-if="power('b_home_work')" height="auto">
            <module title="待办事项" >
                <div class="backlog flex-wrap">
                    <div v-for="(item, i) in stayDataList" :key="i" class="item-box">
                        <!-- <div class="item" v-if="power(item.unique_key)" @click="navigateTo(item.to_page);"> -->
                        <div class="item" @click="navigateTo(item.to_page);">
                            <div>{{item.value}}</div>
                            <label>{{item.name}}</label>
                        </div>
                    </div>
                </div>
            </module>

            <module title="常用功能">
                <div class="history flex-wrap">
                    <div v-for="(item, i) in commonFunList" :key="i" class="item-box">
                        <div class="item" @click="navigateTo({name:item.key});">{{item.name}}</div>
                    </div>
                </div>
            </module>
        </module-group>

        <module v-if="power('b_home_work') && power('m_order_sell')" title="销售动态(近15天)">
            <charts type="bar" :data="salesChartsData" height="375"></charts>
        </module>

    </page>
</template>

<script>
	import charts from '@/components/charts/index.vue'
    import {mapGetters} from 'vuex'

	export default {
		name: 'home',
		
		components: {
			charts
		},
		
		data() {
			return {
                todayDataList: [],
                stayDataList: [],
                commonFunList: [],
                salesChartsData: [],
                returnChartsData: []
            }
		},
        computed: {
            ...mapGetters(['power'])
        },

        mounted() {
            this.getTodayData();
            this.getStayItems();
            this.getCommonFun();
            this.getSalesCharts();
            // this.getReturnCharts();
        },


        methods: {
            // 今日实时数据
            getTodayData() {
                this.request({
                    url: '/workbench/today',
                    success: data => {
                        this.todayDataList = data;
                    }
                });
            },

            // 待办事项
            getStayItems() {
                this.request({
                    url: '/workbench/stayItem',
                    success: data => {
                        this.stayDataList = data;
                    }
                });
            },

            // 常用功能
            getCommonFun() {
                this.request({
                    url: '/workbench/common_func',
                    success: data => {
                        this.commonFunList = data;
                    }
                });
            },

            getSalesCharts() {
                this.request({
                    url: '/workbench/saleDynamic',
                    success: data => {
                        this.salesChartsData = [{
                            type: '支付金额',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.payment_money
                                }
                            })
                        }, {
                            type: '商品数量',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.order_product_count
                                }
                            })
                        }];
                    }
                });
            },

            getReturnCharts() {
                this.request({
                    url: '/workbench/returnDynamic',
                    success: data => {
                        this.returnChartsData = [{
                            type: '退款金额',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.refundMoney
                                }
                            })
                        }, {
                            type: '退货金额',
                            data: Array.from(data, item => {
                                return {
                                    name: item.title,
                                    value: item.returnMoney
                                }
                            })
                        }];
                    }
                });
            }


        }
	}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/style/theme';

  .welcome {
    background: linear-gradient(180deg, #FFFFFF, #EDFBFF);

    img {
      width: 550px;
    }
  }

  .realtime-total {
    margin-left: 20px;
    margin-bottom: 20px;

    .item {
      box-sizing: border-box;
      height: 114px;
      border: 1px solid #eee;
      padding: 18px 26px;

      &.z-active {
        cursor: pointer;

        &:hover {
          theme-border(main)
        }
      }

      &-box {
        box-sizing: border-box;
        width: 16.6666%;
        padding-right: 20px;
        padding-top: 20px;

        @media screen and (max-width: 1700px) {
          & {
            width: 20%;
          }
        }
        @media screen and (max-width: 1400px) {
          & {
            width: 25%;
          }
        }
        @media screen and (max-width: 1200px) {
          & {
            width: 33.3333%;
          }
        }
        @media screen and (max-width: 900px) {
          & {
            width: 50%;
          }
        }
      }

      label {
        font-size: 14px;
        color: #666;
      }

      div {
        margin: 10px 0;
        font-size: 30px;
        font-weight: bold;
      }

      p {
        font-size: 12px;
        color: #666;

        span:nth-child(n+2) {
          margin-left: 1em;
        }

        .tf {
          margin-left: .5em;
        }
      }
    }
  }

  .backlog {
    margin: 0 0 18px 18px;

    .item {
      padding: 16px 0 14px;
      text-align: center;
      background: #F9F9F9;
      cursor: pointer;

      &:hover {
        theme-background(main);

        div,
        label {
          color: #fff;
        }
      }

      &-box {
        box-sizing: border-box;
        width: 25%;
        padding-right: 10px;
        padding-top: 10px;
        @media screen and (max-width: 1500px) {
          & {
            width: 33.333%;
          }
        }
        @media screen and (max-width: 1100px) {
          & {
            width: 50%;
          }
        }
        @media screen and (max-width: 900px) {
          & {
            width: 100%;
          }
        }
      }

      div {
        margin-bottom: 5px;
        font-size: 30px;
        font-weight: bold;
      }

      label {
        font-size: 13px;
        color: #666;
      }
    }
  }

  .history {
    margin: 0 0 14px 14px;

    .item {
      border: 1px solid #eee;
      line-height: 42px;
      font-size: 14px;
      text-align: center;
      color: #333;
      cursor: pointer;

      &:hover {
        font-weight: bold;
        color: #000;
        theme-border(main);
      }

      &-box {
        box-sizing: border-box;
        width: 16.6666%;
        padding-right: 14px;
        padding-top: 14px;

        @media screen and (max-width: 1800px) {
          & {
            width: 20%;
          }
        }
        @media screen and (max-width: 1600px) {
          & {
            width: 25%;
          }
        }
        @media screen and (max-width: 1300px) {
          & {
            width: 33.3333%;
          }
        }
        @media screen and (max-width: 1000px) {
          & {
            width: 50%;
          }
        }
        @media screen and (max-width: 700px) {
          & {
            width: 100%;
          }
        }
      }
    }
  }
</style>
